module.exports = __webpack_public_path__ + "static/media/zenmasaza.com.d8c4fb68.png";